/* eslint-disable */
import PropTypes from 'prop-types';
import {
  USER_SERVICE_PRESENCE_STATUS_AWAY,
  USER_SERVICE_PRESENCE_STATUS_OFFLINE,
  USER_SERVICE_PRESENCE_STATUS_PRESENT,
  USER_SERVICE_PRESENCE_STATUS_UNKNOWN,
} from '../../Constants/User/User.constants';
import AddressEntityPropTypes from '../Address/Address.service.props';
import I18nEntityPropTypes from '../I18n/I18n.service.props';

/**
 * The user's presence
 */
const userPresence = PropTypes.oneOf([
  USER_SERVICE_PRESENCE_STATUS_AWAY,
  USER_SERVICE_PRESENCE_STATUS_OFFLINE,
  USER_SERVICE_PRESENCE_STATUS_PRESENT,
  USER_SERVICE_PRESENCE_STATUS_UNKNOWN,
]);

/**
 * A user
 */
const user = PropTypes.shape({
  /**
   * The url to the users avatar
   */
  avatarUrl: PropTypes.string,

  /**
   * The user's name
   */
  displayName: PropTypes.string.isRequired,

  /**
   * The user's email
   */
  email: PropTypes.string,

  /**
   * The user's first name
   */
  firstName: PropTypes.string,

  /**
   * The user's full name
   */
  fullName: PropTypes.string,

  /**
   * The `id` of the user
   */
  id: PropTypes.string.isRequired,

  /**
   * The initals of the user's first and last names or the first two letters of their `displayName`
   */
  initials: PropTypes.string.isRequired,

  /**
   * The preferred `lang` of the user
   */
  lang: I18nEntityPropTypes.lang,

  /**
   * The user's last name
   */
  lastName: PropTypes.string,

  /**
   * The user's `login` credentials
   */
  login: PropTypes.string.isRequired,

  /**
   * The user's middle name
   */
  middleName: PropTypes.string,

  /**
   * The user's phone number
   */
  mobilePhone: PropTypes.string,

  /**
   * The user's postal address
   */
  postalAddress: AddressEntityPropTypes.address,

  /**
   * The user's presence
   */
  presence: userPresence.isRequired,

  /**
   * The user's street address
   */
  streetAddress: AddressEntityPropTypes.address,

  /**
   * The user's timezone
   */
  timezone: PropTypes.string,

  /**
   * The user's username
   */
  username: PropTypes.string,
});

const UserEntityPropTypes = {
  /**
   * A user
   */
  user,

  /**
   * The user's presence
   */
  userPresence,
};

export default UserEntityPropTypes;
